import { isValidBIC, isValidIBAN } from 'ibantools'
import { z } from 'zod'

import { bicFromIban, isFinnishIban } from '../bankAccountUtils'
import { validationErrors } from './validationErrors'

export const IBANSchema = z.string().refine(
  (value) => {
    if (isValidIBAN(value)) {
      if (isFinnishIban(value)) {
        if (bicFromIban(value)) {
          return true
        }
        return false // Finnish IBAN must have a valid BIC
      }
      return true
    }
    return false
  },
  {
    message: validationErrors.invalid_iban,
  }
)

export const IBANFromCoreSchema = z.union([
  z.literal(''), // iban can be empty string in core db
  IBANSchema,
])

export const BICSchema = z.string().refine(isValidBIC, {
  message: validationErrors.invalid_bic,
})

export const BICFromCoreSchema = z.union([
  z.literal(''), // bic can be empty string in core db
  BICSchema,
])

export const PhoneNumberFromCoreSchema = z
  .string()
  .max(20, {
    message: validationErrors.invalid_phone_number,
  })
  .regex(/^\+?[0-9]+$/, {
    message: validationErrors.invalid_phone_number,
  })
